import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

export default defineModule({
    name: 'redirects',
    routes: [
        {
            path: '/redirects',
            meta: {
                layout: 'app',
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
            children: [
                {
                    path: '',
                    name: 'redirects',
                    component: () => import('#modules/redirects/pages/index.vue'),
                    permissions: [AppPermissions.ManageRedirects],
                },
            ],
        },
    ],
});
